import {
  Configuration,
  PublicClientApplication,
  RedirectRequest,
} from '@azure/msal-browser'

const clientId = process.env.REACT_APP_MS_CLIENT_ID || ''
const tenantId = process.env.REACT_APP_MS_TENANT_ID || ''

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: '/',
    postLogoutRedirectUri: '/redirect',
    navigateToLoginRequestUrl: false,
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
  cache: {
    claimsBasedCachingEnabled: true,
    cacheLocation: 'localStorage',
  },
}

export const loginRequest: RedirectRequest = {
  scopes: ['User.Read', 'Group.Read.All'],
  prompt: 'login',
}

const msalInstance = new PublicClientApplication(msalConfig)

export default msalInstance
